<template>
    <div v-if="openProps" class="image_slider">
        <div class="gallery" v-if="this.itemProps.values.length > 0">
            <ContentsArea :currentIndexProps="currentIndex" :srcProps="this.itemProps.values"></ContentsArea>
            <a class="controller btn_box left" @click="goToLeft()">
                <div>◀</div>
            </a>
            <a class="controller btn_box right" @click="goToRight()">
                <div>▶</div>
            </a>
        </div>
        <div class="gallery_thumbnails">
            <div class="thumbnails_contents">
                <div class="thumbnail" v-for="(item, index) in this.itemProps.values" v-bind:key="item.seq"
                     @click="goToIndex(index)" :class="currentIndex === index ? 'active' : ''">
                    <img
                        :src="item.thumbnailImageUrl"
                        alt=""
                        @error="(e)=>e.target.src = '/images/ic/control/check-box-off.svg'"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ContentsArea from './contentsArea';
import { copyStyles } from '@/static';

export default {
  name: 'image-slider',
  props: ['imageSliderModalOpenProps', 'openProps', 'itemProps', 'clickedIndexProps', 'windowProps'],
  components: {ContentsArea},
  data() {
    return {
      imageSliderRef: null,
      currentIndex: 0
    }
  },
  beforeDestroy() {
    if (this.imageSliderRef !== null) {
      this.imageSliderRef.removeEventListener('click', this.handelEvent);
      this.imageSliderRef.removeEventListener('mousedown', this.handelEvent);
      this.imageSliderRef.removeEventListener('mouseup', this.handelEvent);
      this.imageSliderRef.removeEventListener('keyup', this.handelEvent);
      this.imageSliderRef.removeEventListener('keydown', this.handelEvent);
      this.imageSliderRef.removeEventListener('wheel', this.handelEvent);
    }
  },
  watch: {
    openProps() {
      if (this.openProps) {
        this.openPortal();
      }
    },
    clickedIndexProps() {
      this.currentIndex = this.clickedIndexProps;
    }
  },
  methods: {
    openPortal() {
      this.imageSliderRef = window.open("", "", "width=900, height=600, left=300, top=200");

      try {
        this.imageSliderRef.focus();
        const head = this.imageSliderRef.document.createElement('head');
        const title = this.imageSliderRef.document.createElement('title');
        title.innerHTML = this.itemProps.sliderTitle;
        head.appendChild(title);

        this.imageSliderRef.document.head.appendChild(head);
        this.imageSliderRef.document.body.appendChild(this.$el);
        copyStyles(window.document, this.imageSliderRef.document);

        this.imageSliderRef.addEventListener('unload', () => {
          this.closePortal();
        });
        this.imageSliderRef.addEventListener('click', this.handelEvent);
        this.imageSliderRef.addEventListener('mousedown', this.handelEvent);
        this.imageSliderRef.addEventListener('mouseup', this.handelEvent);
        this.imageSliderRef.addEventListener('keyup', this.handelEvent);
        this.imageSliderRef.addEventListener('keydown', this.handelEvent);
        this.imageSliderRef.addEventListener('wheel', this.handelEvent);
      } catch (e) {
        this.$emit('closeSlider');
        this.windowProps.alert(this.$t('alert.disable_popup_blocker'));
        return
      }
    },
    closePortal() {
      this.$emit('closeSlider');
      if (this.imageSliderRef !== null) {
        this.imageSliderRef.close();
      }
    },
    focusPortal(index) {
      if (this.imageSliderRef !== null) {
        this.imageSliderRef?.close();
        this.currentIndex = index;
      }
    },
    goToLeft() {
      if (this.currentIndex === 0)
        this.currentIndex = this.itemProps.values.length - 1;
      else
        this.currentIndex -= 1;
    },
    goToRight() {
      if (this.currentIndex === (this.itemProps.values.length - 1))
        this.currentIndex = 0;
      else
        this.currentIndex += 1;
    },
    goToIndex(index) {
      this.currentIndex = index;
    },
    handelEvent() {
      localStorage.setItem('time', this.moment());
    },
  }
}
</script>
<style lang="scss">
    .image_slider {
      height: var(--app-height);

        background: var(--grey100);
        .gallery {
            height: calc(100% - 90px);
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;

            .vld-overlay {
                height: calc(100vh - 90px);
            }

            .controller {
                width: 50px;
                height: 100px;
                position: absolute;
                top: calc((100vh - 100px)/2 - 50px);
                z-index: 9999;
                background: var(--overlays-dark);
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                user-select: none;

                div {
                    font-size: 20px;
                    color: var(--white);
                }

                &.left {
                    left: 0;
                }

                &.right {
                    right: 0;
                }
            }

            .downLoad_file {
                cursor: pointer;
                z-index: 2;
            }

            .gallery_frame {
                display: flex;
                justify-content: center;
                align-items: center;

                video {
                    width: 100%;
                    max-height: calc(100vh - 90px);
                }

                img {
                    max-width: 100%;
                    max-height: calc(100vh - 90px);
                }
            }
        }
        .gallery_thumbnails {
            background: var(--grey100);

            .thumbnails_contents {
                display: flex;
                justify-content: center;
                align-items: center;

                .thumbnail {
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 120px;
                    height: 90px;
                    margin-right: 4px;
                    overflow: hidden;
                    box-sizing: border-box;

                    img {
                        width: 100%;
                    }

                    &.active {
                        border: 2px solid var(--white);
                    }
                }
                .thumbnail:last-child {
                    margin-right: 0px;
                }
            }
        }
    }
</style>
